export default __webpack_public_path__ + "static/media/img-signup.6dd99bcc.svg";